var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, ElementRef, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { PageScrollService } from 'ngx-page-scroll-core';
import { Observable, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as moment from 'moment';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import * as fromGlobalStore from '@ibe/store/index';
import { INDRACustomerAccountService } from '@ibe.services/customer-account.indra.service';
import { INDRAAuthenticationService } from '@ibe/services';
import * as UserActions from '@ibe/store/actions/user.actions';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { HttpClient } from '@angular/common/http';
import { INDRA_US_STATES_URL, INDRA_CA_STATES_URL, INDRA_BR_STATES_URL, INDRA_AU_STATES_CREATE_ACCOUNT_URL, INDRA_AR_STATES_CREATE_ACCOUNT_URL, COUNTRIES_TRANSLATION_KEY } from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { ScreenService } from '@ibe/services/ui';
import { INDRADateService } from '@ibe.services/date.indra.service';
var INDRASignUpComponent = /** @class */ (function () {
    function INDRASignUpComponent(sidebarService, store, pageScrollService, globalStore, fb, customerAccountService, authenticationService, storage, _http, document, ibeAdminService, screen, dateService) {
        var _this = this;
        this.sidebarService = sidebarService;
        this.store = store;
        this.pageScrollService = pageScrollService;
        this.globalStore = globalStore;
        this.fb = fb;
        this.customerAccountService = customerAccountService;
        this.authenticationService = authenticationService;
        this.storage = storage;
        this._http = _http;
        this.document = document;
        this.ibeAdminService = ibeAdminService;
        this.screen = screen;
        this.dateService = dateService;
        this.isAlive = true;
        this.treatmentConsent = undefined;
        this.formCreate = new FormGroup({});
        this.triedToSubmit = false;
        this.showCPF = false;
        this.socialImported = null;
        this.importError = false;
        this.currentYear = new Date().getFullYear();
        this.hasChanges$ = Observable.create(function (observer) {
            _this.formCreate.valueChanges.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (values) {
                var changes = Object.keys(values).filter(function (key) { return values[key] != _this.formCreateValueOld[key]; });
                observer.next(changes.length > 0);
            });
        });
        this.consents = [];
        this.sub$ = new Subscription();
        this.countryCodes$ = this.store.select(fromStore.getCountryCodes);
        this.mediaType = 'TP';
        this.stateCodes = [];
        this.stateCodesUS = [];
        this.stateCodesCA = [];
        this.stateCodesBR = [];
        this.stateCodesAU = [];
        this.stateCodesAR = [];
        this.stateOptions = Array();
        this.countriesWithStateValues = ['BR', 'CA', 'US', 'AU', 'AR'];
        this.showStateField = false;
        this.showErrorMessage = false;
        this.showEmailError = false;
        this.showFieldError = false;
        this.isLoading = false;
        this.isMobile = false;
        this.isMinor = false;
        this.createForms();
        this.INDRA_getStateCodes();
        this.screen.isMobile().subscribe(function (value) {
            _this.isMobile = value;
        });
        /* NOTE: check if needed
        this.formCreate.statusChanges
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(status => {
                if (status === 'VALID') {
                    this.formCreateValueOld = { ...this.formCreate.value };
                }
            });
        */
    }
    INDRASignUpComponent.prototype.ngOnInit = function () {
        // this.formCreateValueOld = { ...this.formCreate.value }; // TODO check if needed
        var _this = this;
        this.sub$.add(this.globalStore.select(fromGlobalStore.getSelectedCountryCodesOpts).subscribe(function (data) {
            if (data && data.length) {
                _this.countryCodes = _this.INDRA_getCountryCodesOptions(data);
            }
        }));
        this.sub$.add(this.store.select(fromStore.getCountryCodes).subscribe(function (data) {
            if (data && data.length) {
                _this.countryCodesWithPrefix = _this.INDRA_getCountryCodesOptionsPrefix(data);
            }
        }));
        this.typeOptions = [
            { text: this.INDRA_getTranslation('createAccountSidebar.text.home'), value: 6 },
            { text: this.INDRA_getTranslation('createAccountSidebar.text.mobile'), value: 10 },
            { text: this.INDRA_getTranslation('createAccountSidebar.text.business'), value: 7 }
        ];
        this.titleOptions = [
            { text: this.INDRA_getTranslation('createAccountSidebar.text.mr'), value: 'Mr.' },
            { text: this.INDRA_getTranslation('createAccountSidebar.text.mrs'), value: 'Mrs.' },
        ];
        this.treatmentConsentOptions = [
            { label: this.INDRA_getTranslation('createAccountSidebar.text.yes'), selected: false, id: 'treatment_consent-yes' },
            { label: this.INDRA_getTranslation('createAccountSidebar.text.no'), selected: false, id: 'treatment_consent-no' }
        ];
    };
    INDRASignUpComponent.prototype.INDRA_getCountryCodesOptions = function (countryCodes) {
        var _this = this;
        var options = countryCodes.map(function (item) { return ({
            value: item.value,
            text: _this.INDRA_getTranslation(item.text)
        }); });
        options.sort(function (a, b) { return a.text.localeCompare(b.text); });
        return options;
    };
    INDRASignUpComponent.prototype.INDRA_getCountryCodesOptionsPrefix = function (countryCodes) {
        var _this = this;
        var options = countryCodes.map(function (item) { return ({
            code: item.code,
            name: _this.INDRA_getTranslation(COUNTRIES_TRANSLATION_KEY + item.code.toLowerCase()),
            dial_code: item.dial_code
        }); });
        options.sort(function (a, b) { return a.name.localeCompare(b.name); });
        return options;
    };
    INDRASignUpComponent.prototype.createForms = function () {
        this.formCreate = this.fb.group({
            birthdate: [null, [Validators.required, this.INDRA_checkDateValidity]],
            name_prefix: [null, Validators.required],
            givenName: [null, Validators.required],
            surname: [null, Validators.required],
            nationality: [null, Validators.required],
            phone_prefix: [null, Validators.required],
            phone_type: [null, Validators.required],
            phone_number: [null, Validators.required],
            email: [null, {
                    validators: [Validators.required, Validators.email],
                    updateOn: 'blur'
                }],
            country: [null, Validators.required],
            city: [null, Validators.required],
            emailResponsibleAdult: [null, {
                    validators: [Validators.required, Validators.email],
                    updateOn: 'blur'
                }],
            password: [null, [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9]).{8,32}$')]],
            repassword: [null],
            terms_conditions: [null, Validators.required],
            treatment_consent: [null, Validators.required],
            communication_flytap_email: [null],
            communication_flytap_sms: [null],
            communication_milesego_email: [null],
            communication_milesego_sms: [null],
            cpf: [null],
            nif: [null],
            state: [null]
        });
        var MatchPassword = function (AC) {
            var password = AC.get('password').value;
            var confirmPassword = AC.get('repassword').value;
            if (confirmPassword) {
                if (password != confirmPassword) {
                    AC.get('repassword').setErrors({ MatchPassword: true });
                }
                else {
                    AC.get('repassword').setErrors(null);
                }
            }
            else {
                AC.get('repassword').setErrors({ required: true });
            }
            return null;
        };
        this.formCreate.setValidators([MatchPassword, this.INDRA_checkNameLength('givenName', 'surname')]);
        this.formCreate.controls['email'].setValue(null);
        this.formCreate.controls['password'].setValue(null);
        this.INDRA_formValueChangesUpdateName();
        this.INDRA_formValueChangesUpdateAddress();
    };
    INDRASignUpComponent.prototype.INDRA_getStateCodes = function () {
        var _this = this;
        var usfilePromise = this._http.get(INDRA_US_STATES_URL).toPromise();
        usfilePromise.then(function (data) {
            _this.stateCodesUS = data;
        }, function (err) {
            console.error(err);
        });
        var cafilePromise = this._http.get(INDRA_CA_STATES_URL).toPromise();
        cafilePromise.then(function (data) {
            _this.stateCodesCA = data;
        }, function (err) {
            console.error(err);
        });
        var brfilePromise = this._http.get(INDRA_BR_STATES_URL).toPromise();
        brfilePromise.then(function (data) {
            _this.stateCodesBR = data;
        }, function (err) {
            console.error(err);
        });
        var aufilePromise = this._http.get(INDRA_AU_STATES_CREATE_ACCOUNT_URL).toPromise();
        aufilePromise.then(function (data) {
            _this.stateCodesAU = data;
        }, function (err) {
            console.error(err);
        });
        var arfilePromise = this._http.get(INDRA_AR_STATES_CREATE_ACCOUNT_URL).toPromise();
        arfilePromise.then(function (data) {
            _this.stateCodesAR = data;
        }, function (err) {
            console.error(err);
        });
    };
    INDRASignUpComponent.prototype.INDRA_socialMedia = function (type) {
        this.mediaType = type;
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    INDRASignUpComponent.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
    };
    INDRASignUpComponent.prototype.INDRA_saveSidebar = function () {
        var _this = this;
        this.triedToSubmit = true;
        if (this.formCreate.valid) {
            this.validateAllFormFields(this.formCreate);
            this.triedToSubmit = false;
            var formAccessCode = (this.formCreate.controls['phone_prefix'].value).replace(/\s/g, '');
            var accessCode = formAccessCode.replace('+', '');
            this.consents = this.INDRA_getConsents();
            var payload = {
                birthdate: this.formCreate.controls['birthdate'].value,
                personName: {
                    namePrefix: this.formCreate.controls['name_prefix'].value,
                    givenName: this.formCreate.controls['givenName'].value,
                    surname: this.formCreate.controls['surname'].value,
                },
                telephone: {
                    countryAccessCode: accessCode,
                    phoneLocationType: this.formCreate.controls['phone_type'].value,
                    phoneNumber: this.formCreate.controls['phone_number'].value,
                },
                parentalEmail: this.formCreate.controls['emailResponsibleAdult'].value,
                address: {
                    countryCode: this.formCreate.controls['country'].value,
                    cityName: this.formCreate.controls['city'].value,
                    stateProv: this.formCreate.controls['state'].value,
                },
                cpf: this.formCreate.controls['cpf'].value,
                nif: this.formCreate.controls['nif'].value,
                password: this.formCreate.controls['password'].value,
                nationality: this.formCreate.controls['nationality'].value,
                socialMedia: {
                    mediaType: this.mediaType,
                    email: this.formCreate.controls['email'].value,
                },
                consentsList: this.consents ? this.consents : []
            };
            if (this.formCreate.get('country').value !== 'BR') {
                delete payload['cpf'];
            }
            else if (this.formCreate.get('country').value === 'BR') {
                payload.cpf = this.formCreate.controls['cpf'].value;
                delete payload['nif'];
            }
            if (this.formCreate.get('country').value !== 'PT') {
                delete payload['nif'];
            }
            else if (this.formCreate.get('country').value === 'PT') {
                payload.nif = this.formCreate.controls['nif'].value;
                delete payload['cpf'];
            }
            this.isLoading = true;
            this.customerAccountService.createCustomerAccount(payload).subscribe(function (res) {
                if (res && res.status === '200') {
                    _this.isLoading = false;
                    if (res.tapUserProfileBean) {
                        var _a = res.tapUserProfileBean, userProfile = _a.userProfile, userAddress = _a.userAddress;
                        var defaultCurrency = res.tapUserProfileBean.defaultCurrency;
                        var userData = __assign({}, userProfile, { userAddress: userAddress, userProfile: userProfile, defaultCurrency: defaultCurrency });
                        _this.storage.set('userData', userData);
                        _this.userInfo = __assign({}, userProfile, { defaultCurrency: defaultCurrency });
                        _this.store.dispatch(new UserActions.PutUserInfoAction(_this.userInfo));
                        _this.closeSidebar();
                    }
                    _this.consents = [];
                }
                else {
                    if (res.errors) {
                        _this.isLoading = false;
                        var error = res.errors[0].desc.split('-');
                        if (error[0] && error[0].trim() === 'REPEATED_CUSTOMER_EMAIL') {
                            _this.showEmailError = true;
                        }
                        else {
                            _this.showEmailError = false;
                        }
                        if (error[2] && error[2].trim() === 'Invalid Fiscal ID') {
                            var errorField = _this.formCreate.get('country').value === 'BR' ? 'CPF' : 'NIF';
                            _this.INDRA_Errors(_this.formCreate.controls[errorField.toLowerCase()], errorField, true);
                            _this.showFieldError = true;
                        }
                        _this.showErrorMessage = true;
                        _this.INDRA_scrollToError();
                    }
                }
            }, function (error) {
                if (error) {
                    _this.isLoading = false;
                    _this.showErrorMessage = true;
                }
            });
        }
        else {
            this.INDRA_scrollToError();
        }
    };
    INDRASignUpComponent.prototype.INDRA_close = function (event) {
        if (event) {
            this.showErrorMessage = false;
        }
    };
    INDRASignUpComponent.prototype.INDRA_getConsents = function () {
        this.consents = [];
        if (this.formCreate.controls['terms_conditions'].value) {
            this.consents.push('LOYTC');
            this.consents.push('TAPPP');
        }
        if (this.formCreate.controls['treatment_consent'].value) {
            this.consents.push('TAPPROF');
        }
        if (this.formCreate.controls['communication_flytap_email'].value) {
            this.consents.push('TAPEMAIL');
        }
        if (this.formCreate.controls['communication_flytap_sms'].value) {
            this.consents.push('TAPSMS');
        }
        if (this.formCreate.controls['communication_milesego_email'].value) {
            this.consents.push('LOYEMAIL');
        }
        if (this.formCreate.controls['communication_milesego_sms'].value) {
            this.consents.push('LOYSMS');
        }
        return this.consents;
    };
    INDRASignUpComponent.prototype.validateAllFormFields = function (formGroup) {
        var _this = this;
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field);
            if (control instanceof FormControl) {
                // control.markAsTouched({ onlySelf: true });
                control.markAsUntouched({ onlySelf: true });
            }
            else if (control instanceof FormGroup) {
                _this.validateAllFormFields(control);
            }
        });
    };
    INDRASignUpComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        this.sub$.unsubscribe();
    };
    /**************************/
    /* Generic functions      */
    /**************************/
    INDRASignUpComponent.prototype.trackByFn = function (index, item) {
        return index; // or item.id
    };
    /**
     * Returns list of numbers between a specified interval
     * @param {number} start number of interval
     * @param {number} end number of interval
     * @returns {Array} of interval numbers
     */
    INDRASignUpComponent.prototype.INDRA_getInterval = function (start, end, inverted) {
        if (inverted === void 0) { inverted = false; }
        var interval = [];
        for (var i = start; i <= end; i++) {
            interval.push({ text: i, value: i });
        }
        if (inverted)
            return interval.reverse();
        return interval;
    };
    INDRASignUpComponent.prototype.INDRA_getIntervalYearExpiration = function () {
        var interval = [];
        var start = moment().format('YYYY');
        var end = moment().add(30, 'years').format('YYYY');
        for (var i = parseFloat(start); i <= parseFloat(end); i++) {
            interval.push({ text: i, value: i });
        }
        return interval;
    };
    /**
     * Returns class to a formControl if it's not valid
     * @param {FormControl} formControl to check if has any error
     * @returns {Object} with matched classes
     */
    INDRASignUpComponent.prototype.INDRA_hasErrors = function (control) {
        return control.invalid && this.triedToSubmit;
    };
    INDRASignUpComponent.prototype.INDRA_hasErrorsClasses = function (control, $event) {
        if ($event === void 0) { $event = null; }
        return this.INDRA_hasErrors(control) && this.formCreate.touched ? 'has-error' : '';
    };
    INDRASignUpComponent.prototype.INDRA_Errors = function (control, field, invalid) {
        if (field === void 0) { field = null; }
        var errors = [];
        if (Object.is('maxNameCharReached', control)) {
            if (this.formCreate.hasError('maxNameCharReached')) {
                errors.push('bookingDetails.error.createAccMaxNameCharExceeded');
            }
        }
        else {
            if (control.hasError('required')) {
                errors.push(field + " " + this.INDRA_getTranslation('createAccountSidebar.text.isRequired'));
            }
            if (control.hasError('invalidDate')) {
                errors.push(field + " " + this.INDRA_getTranslation('createAccountSidebar.text.isRequired'));
            }
            if (control.hasError('email')) {
                errors.push(field + " " + this.INDRA_getTranslation('createAccountSidebar.text.isNotValid'));
            }
            if (control.hasError('MatchPassword')) {
                errors.push("" + this.INDRA_getTranslation('createAccountSidebar.text.passwordNotMatch'));
            }
            if (control.hasError('pattern') && field != "" + this.INDRA_getTranslation('createAccountSidebar.text.password')) {
                errors.push(field + " " + this.INDRA_getTranslation('createAccountSidebar.text.isNotValid'));
            }
            if (control.hasError('pattern') && field == "" + this.INDRA_getTranslation('createAccountSidebar.text.password')) {
                errors.push("" + this.INDRA_getTranslation('createAccountSidebar.text.mustHaveAtLeast'));
            }
            if ((field === 'NIF' || field === 'CPF') && invalid) {
                errors.push(field === 'NIF' ? "" + this.INDRA_getTranslation('createAccountSidebar.text.invalidNIF') : "" + this.INDRA_getTranslation('createAccountSidebar.text.invalidCPF'));
            }
        }
        return errors.join('; ');
    };
    INDRASignUpComponent.prototype.INDRA_isInvalid = function (field) {
        return this.formCreate.controls[field].invalid && this.formCreate.controls[field].dirty;
    };
    INDRASignUpComponent.prototype.INDRA_scrollToError = function () {
        var _this = this;
        var sidebar = this.$sidebar.nativeElement;
        var sidebarScrollPosition = sidebar.scrollTop;
        setTimeout(function () {
            sidebar.scrollTo({
                left: 0,
                top: !_this.showErrorMessage ? (sidebar.querySelector('.input-error').closest('.form-field').getBoundingClientRect().top + sidebarScrollPosition) - 100 : 0,
                behavior: 'smooth'
            });
        }, 100);
    };
    INDRASignUpComponent.prototype.INDRA_formChanges = function (value) {
        var _this = this;
        if (value) {
            this.stateCodes = [];
            this.stateOptions = [];
            if (this.countriesWithStateValues.includes(value)) {
                this.showStateField = true;
                this.formCreate.controls['state'].setValidators(Validators.required);
                switch (value) {
                    case 'US':
                        this.stateCodes = this.stateCodesUS;
                        break;
                    case 'CA':
                        this.stateCodes = this.stateCodesCA;
                        break;
                    case 'BR':
                        this.stateCodes = this.stateCodesBR;
                        break;
                    case 'AU':
                        this.stateCodes = this.stateCodesAU;
                        break;
                    case 'AR':
                        this.stateCodes = this.stateCodesAR;
                        break;
                    default:
                        break;
                }
                this.formCreate.controls['state'].patchValue(null);
                this.stateCodes.forEach(function (item) {
                    _this.stateOptions.push({
                        text: item.state,
                        value: item.code
                    });
                });
            }
            else {
                if (this.formCreate.controls['state']) {
                    this.formCreate.controls['state'].patchValue(null);
                    this.formCreate.controls['state'].clearValidators();
                    this.formCreate.controls['state'].updateValueAndValidity();
                }
                this.showStateField = false;
            }
        }
        this.INDRA_handleNationality();
    };
    INDRASignUpComponent.prototype.INDRA_checkIfMinor = function () {
        if (this.formCreate.controls['birthdate'].valid) {
            var birthDate = this.formCreate.controls['birthdate'].value;
            var age = this.dateService.INDRA_computeDifferenceDateOnly(birthDate, new Date().toString()).years();
            if (age < 18) {
                // show and enable emailResponsibleAdult field
                this.isMinor = true;
                this.formCreate.controls['emailResponsibleAdult'].setValidators([Validators.required, Validators.email]);
                return;
            }
        }
        // hide and disable emailResponsibleAdult field
        this.isMinor = false;
        this.formCreate.controls['emailResponsibleAdult'].patchValue(null);
        this.formCreate.controls['emailResponsibleAdult'].clearValidators();
        this.formCreate.controls['emailResponsibleAdult'].updateValueAndValidity();
    };
    INDRASignUpComponent.prototype.INDRA_withoutDiscount = function () {
        this.sidebarService.closeSidebar();
        this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
    };
    INDRASignUpComponent.prototype.INDRA_changedTreatmentConsent = function (event) {
        this.treatmentConsent = event === undefined ? undefined : (event === 'treatment_consent-yes' ? true : false);
        this.formCreate.controls['treatment_consent'].setValue(this.treatmentConsent);
    };
    // TODO: waiting for updates
    INDRASignUpComponent.prototype.TAP_handleSocialImport = function (socialNetwork) {
        this.socialImported = socialNetwork;
        try {
            if (socialNetwork === 'facebook') {
                this.formCreate.get('firstName').setValue('Mark');
                this.formCreate.get('lastName').setValue('Zuckerberg');
                this.formCreate.get('title').setValue('Mr');
                this.formCreate.get('date_of_birth_year').setValue('1984');
                this.formCreate.get('nationality').setValue('US');
                this.formCreate.get('country').setValue('US');
                this.formCreate.get('email').setValue('mark@facebook.com');
            }
            else if (socialNetwork === 'google') {
                this.formCreate.get('firstName').setValue('Sundar');
                this.formCreate.get('lastName').setValue('Pichai');
                this.formCreate.get('title').setValue('Mr');
                this.formCreate.get('date_of_birth_year').setValue('1972');
                this.formCreate.get('nationality').setValue('IN');
                this.formCreate.get('country').setValue('IN');
                this.formCreate.get('email').setValue('sundar@google.com');
            }
        }
        catch (error) {
            console.error('Error on social import', error);
            this.importError = true;
        }
        this.INDRA_handleNationality();
    };
    INDRASignUpComponent.prototype.INDRA_handleNationality = function () {
        var nationalitySelected = this.formCreate.get('country').value;
        switch (nationalitySelected) {
            case 'PT':
                this.formCreate.controls['nif'].setValidators([Validators.required]);
                this.formCreate.controls['cpf'].clearValidators();
                this.formCreate.controls['state'].clearValidators();
                break;
            case 'BR':
                this.formCreate.controls['cpf'].setValidators([Validators.required]);
                this.formCreate.controls['nif'].clearValidators();
                this.formCreate.controls['state'].clearValidators();
                break;
            case 'US':
            case 'CA':
                this.formCreate.controls['state'].setValidators([Validators.required]);
                this.formCreate.controls['cpf'].clearValidators();
                this.formCreate.controls['nif'].clearValidators();
                break;
            default:
                this.formCreate.controls['nif'].clearValidators();
                this.formCreate.controls['cpf'].clearValidators();
                this.formCreate.controls['state'].clearValidators();
                break;
        }
        this.formCreate.controls['nif'].updateValueAndValidity();
        this.formCreate.controls['cpf'].updateValueAndValidity();
        this.formCreate.controls['state'].updateValueAndValidity();
    };
    INDRASignUpComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRASignUpComponent.prototype.INDRA_formValueChangesUpdateName = function () {
        var _this = this;
        this.sub$.add(this.formCreate.get('givenName').valueChanges.subscribe(function (data) {
            var regex = /^[a-zA-Z0-9_ ]+$/;
            var isValid = regex.test(data);
            if (isValid) {
                return;
            }
            else {
                if (data && data !== _this.INDRA_removeSpecialCharacters(data)) {
                    _this.formCreate.controls['givenName'].patchValue(_this.INDRA_removeSpecialCharacters(data));
                }
                return;
            }
        }));
        this.sub$.add(this.formCreate.get('surname').valueChanges.subscribe(function (data) {
            var regex = /^[a-zA-Z0-9_ ]+$/;
            var isValid = regex.test(data);
            if (isValid) {
                return;
            }
            else {
                if (data && data !== _this.INDRA_removeSpecialCharacters(data)) {
                    _this.formCreate.controls['surname'].patchValue(_this.INDRA_removeSpecialCharacters(data));
                }
                return;
            }
        }));
        /*
        this.sub$.add(
            this.formCreate.get('birthdate').valueChanges.subscribe((data) => {
                this.INDRA_checkIfMinor();
                return;
            })
        );
        */
    };
    INDRASignUpComponent.prototype.INDRA_formValueChangesUpdateAddress = function () {
        var _this = this;
        this.sub$.add(this.formCreate.get('city').valueChanges.subscribe(function (data) {
            var regex = /^[a-zA-Z0-9_ ]+$/;
            var isValid = regex.test(data);
            if (isValid) {
                return;
            }
            else {
                if (data && data !== _this.INDRA_removeSpecialCharacters(data)) {
                    _this.formCreate.controls['city'].patchValue(_this.INDRA_removeSpecialCharacters(data));
                }
                return;
            }
        }));
    };
    INDRASignUpComponent.prototype.INDRA_removeSpecialCharacters = function (value) {
        return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };
    // The total characters for first and last name should not exceed 31 characters
    INDRASignUpComponent.prototype.INDRA_checkNameLength = function (firstNameControl, secondNameControl) {
        return function (control) {
            if (control.get(firstNameControl).value && control.get(secondNameControl).value) {
                var firstname = control.get(firstNameControl).value.length;
                var lastname = control.get(secondNameControl).value.length;
                if (firstname + lastname > 30) {
                    return { 'maxNameCharReached': true };
                }
                else {
                    return null;
                }
            }
        };
    };
    INDRASignUpComponent.prototype.INDRA_checkDateValidity = function (control) {
        if (control.value) {
            var dateVal = control.value;
            var dateArray = dateVal.split('-');
            if (dateArray.length == 3 && (dateArray[0] === '0' || dateArray[1] === '00' || dateArray[2] === '00')) {
                return { 'invalidDate': true };
            }
        }
        return null;
    };
    return INDRASignUpComponent;
}());
export { INDRASignUpComponent };
